// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zubat: PokeData = {
  "id": 41,
  "name": "zubat",
  "height": 8,
  "weight": 75,
  "base_experience": 49,
  "types": [
    PokeType.POISON,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "wing-attack",
    "bite",
    "supersonic",
    "absorb",
    "toxic",
    "hypnosis",
    "confuse-ray",
    "haze",
    "swift",
    "leech-life",
    "mean-look",
    "poison-fang",
    "astonish",
    "air-cutter",
    "air-slash",
    "cross-poison",
    "venoshock",
    "quick-guard",
    "acrobatics"
  ],
  "moves": [
    "gust",
    "bite",
    "supersonic",
    "confuse-ray",
    "poison-fang",
    "air-slash",
    "acrobatics",
    "chatter",
    "toxic-overload",
    "sky-attack",
    "purify",
    "sludge-bomb",
    "brave-bird"
  ],
  "evolution_chain": {
    "id": 17,
    "item": null,
    "species": [
      {
        "name": "zubat",
        "order": 44,
        "types": [
          PokeType.POISON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "golbat",
        "order": 45,
        "types": [
          PokeType.POISON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 41,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 22,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "crobat",
        "order": 46,
        "types": [
          PokeType.POISON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 42,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 38.75,
    "speed": 55,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
